// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__kUzvX","content":"GlobalSearch_content__3Iy58"};